const defaultColumnNames = {
  analysis: 'analysis',
  group: 'group',
  risk: 'risk',
  ciLo: 'ci_lo',
  ciHi: 'ci_hi',
  riskTime: 'risk_time'
}

export class ForestRowData {
  constructor (rowData = {}, columnNames = {}) {
    this.rowData = rowData
    this.columnNames = Object.assign({}, defaultColumnNames, columnNames)
  }

  get analysis () {
    return this.getValue('analysis')
  }

  get group () {
    return this.getValue('group')
  }

  get risk () {
    return this.getValue('risk')
  }

  get ciLo () {
    return this.getValue('ciLo')
  }

  get ciHi () {
    return this.getValue('ciHi')
  }

  get riskTime () {
    return this.getValue('riskTime')
  }

  getValue (columnName) {
    return this.rowData[this.columnNames[columnName]]
  }
}
